import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RecentBookings = () => {
  const [currentBooking, setCurrentBooking] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const recentBookings = [
    {
      id: 1,
      userName: "Jessica M.",
      userAvatar: "https://randomuser.me/api/portraits/women/44.jpg",
      tourName: "Bali Temple & Rice Terraces",
      location: "Bali, Indonesia",
      timeAgo: "2 minutes ago",
      price: 89,
      groupSize: 4
    },
    {
      id: 2,
      userName: "Alex R.",
      userAvatar: "https://randomuser.me/api/portraits/men/32.jpg",
      tourName: "Santorini Sunset Sailing",
      location: "Santorini, Greece",
      timeAgo: "5 minutes ago",
      price: 145,
      groupSize: 2
    },
    {
      id: 3,
      userName: "Maria L.",
      userAvatar: "https://randomuser.me/api/portraits/women/28.jpg",
      tourName: "Tokyo Food Adventure",
      location: "Tokyo, Japan",
      timeAgo: "8 minutes ago",
      price: 75,
      groupSize: 3
    },
    {
      id: 4,
      userName: "David K.",
      userAvatar: "https://randomuser.me/api/portraits/men/45.jpg",
      tourName: "Amazon Wildlife Safari",
      location: "Manaus, Brazil",
      timeAgo: "12 minutes ago",
      price: 420,
      groupSize: 2
    },
    {
      id: 5,
      userName: "Sophie T.",
      userAvatar: "https://randomuser.me/api/portraits/women/35.jpg",
      tourName: "Maldives Island Hopping",
      location: "Maldives",
      timeAgo: "15 minutes ago",
      price: 199,
      groupSize: 6
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setCurrentBooking((prev) => (prev + 1) % recentBookings?.length);
        setIsVisible(true);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, [recentBookings?.length]);

  const currentBookingData = recentBookings?.[currentBooking];

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-6 z-40 animate-slide-up">
      <div className="bg-white rounded-2xl shadow-2xl border border-border p-4 max-w-sm hover-lift">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-success">Recent Booking</span>
          </div>
          <button
            onClick={handleClose}
            className="p-1 rounded-full hover:bg-muted transition-colors"
          >
            <Icon name="X" size={14} className="text-muted-foreground" />
          </button>
        </div>

        {/* Content */}
        <div className="flex items-center space-x-3">
          {/* User Avatar */}
          <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
            <Image
              src={currentBookingData?.userAvatar}
              alt={currentBookingData?.userName}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Booking Details */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-2 mb-1">
              <span className="font-semibold text-foreground text-sm">
                {currentBookingData?.userName}
              </span>
              <span className="text-xs text-muted-foreground">
                just booked
              </span>
            </div>
            
            <h4 className="font-medium text-foreground text-sm truncate mb-1">
              {currentBookingData?.tourName}
            </h4>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                <Icon name="MapPin" size={12} />
                <span className="truncate">{currentBookingData?.location}</span>
              </div>
              
              <div className="flex items-center space-x-2">
                <div className="flex items-center space-x-1 text-xs text-muted-foreground">
                  <Icon name="Users" size={12} />
                  <span>{currentBookingData?.groupSize}</span>
                </div>
                <div className="text-sm font-bold text-primary">
                  ${currentBookingData?.price}
                </div>
              </div>
            </div>
            
            <div className="text-xs text-muted-foreground mt-1">
              {currentBookingData?.timeAgo}
            </div>
          </div>
        </div>

        {/* Progress Indicator */}
        <div className="flex space-x-1 mt-3">
          {recentBookings?.map((_, index) => (
            <div
              key={index}
              className={`h-1 flex-1 rounded-full transition-colors duration-300 ${
                index === currentBooking ? 'bg-primary' : 'bg-muted'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentBookings;